var _linearGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightModeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "50bfe2f9-e812-4aa4-9dcc-25bdebfa2d5c",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m118.114 139.325c5.859 5.859 15.351 5.859 21.211 0 5.859-5.859 5.859-15.352 0-21.211l-42.422-42.422c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 21.211zm137.886-48.325c8.291 0 15-6.709 15-15v-61c0-8.291-6.709-15-15-15s-15 6.709-15 15v61c0 8.291 6.709 15 15 15zm-165 165c0-8.291-6.709-15-15-15h-61c-8.291 0-15 6.709-15 15s6.709 15 15 15h61c8.291 0 15-6.709 15-15zm302.886-116.675 42.422-42.422c5.859-5.859 5.859-15.352 0-21.211s-15.352-5.859-21.211 0l-42.422 42.422c-5.859 5.859-5.859 15.352 0 21.211s15.351 5.86 21.211 0zm-137.886-18.325c-74.443 0-135 60.557-135 135s60.557 135 135 135 135-60.557 135-135-60.557-135-135-135zm0 240c-57.891 0-105-47.109-105-105s47.109-105 105-105 105 47.109 105 105-47.109 105-105 105zm-137.886 11.675-42.422 42.422c-5.859 5.859-5.859 15.352 0 21.211s15.351 5.859 21.211 0l42.422-42.422c5.859-5.859 5.859-15.352 0-21.211s-15.351-5.86-21.211 0zm275.772 0c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 21.211l42.422 42.422c5.859 5.859 15.351 5.859 21.211 0 5.859-5.859 5.859-15.352 0-21.211zm103.114-131.675h-61c-8.291 0-15 6.709-15 15s6.709 15 15 15h61c8.291 0 15-6.709 15-15s-6.709-15-15-15zm-241 180c-8.291 0-15 6.709-15 15v61c0 8.291 6.709 15 15 15s15-6.709 15-15v-61c0-8.291-6.709-15-15-15z",
    fill: "url(#50bfe2f9-e812-4aa4-9dcc-25bdebfa2d5c)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeDark);
export default __webpack_public_path__ + "static/media/LightModeDark.6a90944c.svg";
export { ForwardRef as ReactComponent };